import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import IconBtn from '../../components/ui/IconBtn';
import Secao from '../../components/ui/Secao';
import { Input, Select } from '../../components/ui/Input';
import CriarCondicaoPagamentoModal from '../cadastros/CriarCondicaoPagamentoModal';
import { ordensCompraApi } from '../../api/compras';
import { fornecedoresApi } from '../../api/fornecedores';
import { produtosApi } from '../../api/produtos';
import { condicoesPagamentoApi } from '../../api/condicoesPagamento';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';
import { useAuth } from '../../context/AuthContext';

export default function OrdemCompraForm({ onVoltar, onSalvo }) {
  useTituloPagina('Nova Ordem de Compra');
  const { usuario } = useAuth();

  const [fornecedores, setFornecedores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [condicoes, setCondicoes] = useState([]);
  const [fornecedorId, setFornecedorId] = useState('');
  const [condicaoPagamentoId, setCondicaoPagamentoId] = useState('');
  const [observacoes, setObservacoes] = useState('');
  const [itens, setItens] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [criandoCondicao, setCriandoCondicao] = useState(false);
  const [erro, setErro] = useState('');

  const carregarCondicoes = () => condicoesPagamentoApi.listar().then(setCondicoes).catch(() => {});

  useEffect(() => {
    fornecedoresApi.listar().then(setFornecedores).catch(() => {});
    produtosApi.listar({ limite: 500 }).then(setProdutos).catch(() => {});
    carregarCondicoes();
  }, []);

  const opcoesFornecedores = [{ value: '', label: 'Selecione...' }, ...fornecedores.map(f => ({ value: f.id, label: f.nome_fantasia }))];
  const opcoesProdutos = [{ value: '', label: 'Selecione...' }, ...produtos.map(p => ({ value: p.id, label: `${p.codigo} - ${p.nome}` }))];
  const opcoesCondicoes = [{ value: '', label: '(em branco)' }, ...condicoes.map(c => ({ value: c.id, label: c.nome }))];

  const adicionarItem = () => setItens(i => [...i, { produto_id: '', quantidade: 1, custo_unitario_esperado: '' }]);
  const removerItem = (idx) => setItens(i => i.filter((_, x) => x !== idx));
  const atualizarItem = (idx, campo, valor) => setItens(i => i.map((item, x) => x === idx ? { ...item, [campo]: valor } : item));

  const salvar = async () => {
    if (!fornecedorId) { setErro('Selecione o fornecedor'); return; }
    const itensValidos = itens.filter(i => i.produto_id && i.quantidade);
    if (itensValidos.length === 0) { setErro('Adicione ao menos um item com quantidade'); return; }
    setSalvando(true);
    setErro('');
    try {
      await ordensCompraApi.criar({
        fornecedor_id: fornecedorId,
        condicao_pagamento_id: condicaoPagamentoId || null,
        observacoes,
        itens: itensValidos
      });
      if (onSalvo) onSalvo();
      onVoltar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18, fontSize: 12 }}>
            <div><span style={{ color: COLORS.textLight }}>Nº OC:</span> <strong style={{ color: COLORS.textMid }}>(gerado ao salvar)</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Data:</span> <strong style={{ color: COLORS.text }}>{new Date().toLocaleDateString('pt-BR')}</strong></div>
            <div><span style={{ color: COLORS.textLight }}>Solicitante:</span> <strong style={{ color: COLORS.text }}>{usuario?.nome}</strong></div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <IconBtn titulo="Voltar" variante="ghost" onClick={onVoltar}>
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5" />
                <path d="m12 19-7-7 7-7" />
              </svg>
            </IconBtn>
            <IconBtn titulo={salvando ? 'Salvando...' : 'Criar Ordem de Compra'} variante="primary" onClick={salvar} disabled={salvando}>
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </IconBtn>
          </div>
        </div>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13 }}>{erro}</p>}

        <Secao titulo="Fornecedor">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, maxWidth: 700 }}>
            <Select label="Fornecedor" options={opcoesFornecedores} value={fornecedorId} onChange={e => setFornecedorId(e.target.value)} />
            <div>
              <Select label="Condição de Pagamento" options={opcoesCondicoes} value={condicaoPagamentoId} onChange={e => setCondicaoPagamentoId(e.target.value)} />
              <button type="button" onClick={() => setCriandoCondicao(true)}
                style={{ background: 'none', border: 'none', color: COLORS.primary, fontSize: 12, cursor: 'pointer', padding: '4px 0' }}>
                + Nova Condição
              </button>
            </div>
          </div>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Itens">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {itens.map((item, idx) => (
              <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', gap: 10, alignItems: 'end' }}>
                <Select label="Produto" options={opcoesProdutos} value={item.produto_id} onChange={e => atualizarItem(idx, 'produto_id', e.target.value)} />
                <Input label="Quantidade" type="number" step="0.001" value={item.quantidade} onChange={e => atualizarItem(idx, 'quantidade', e.target.value)} />
                <Input label="Custo Unitário Esperado R$" type="number" step="0.01" value={item.custo_unitario_esperado} onChange={e => atualizarItem(idx, 'custo_unitario_esperado', e.target.value)} />
                <Btn variante="danger" tamanho="sm" onClick={() => removerItem(idx)}>Remover</Btn>
              </div>
            ))}
            {itens.length === 0 && <p style={{ color: COLORS.textMid, fontSize: 13 }}>Nenhum item adicionado ainda.</p>}
          </div>
          <Btn variante="secondary" onClick={adicionarItem} style={{ marginTop: 14 }}>+ Adicionar Item</Btn>
        </Secao>

        <div style={{ height: 14 }} />

        <Secao titulo="Observações">
          <textarea value={observacoes} onChange={e => setObservacoes(e.target.value)} rows={3}
            style={{ width: '100%', border: `1.5px solid ${COLORS.border}`, borderRadius: 7, padding: '8px 9px', fontSize: 13, fontFamily: 'inherit', resize: 'vertical' }} />
        </Secao>
      </Card>

      {criandoCondicao && (
        <CriarCondicaoPagamentoModal
          onFechar={() => setCriandoCondicao(false)}
          onCriada={(id) => { setCriandoCondicao(false); carregarCondicoes().then(() => setCondicaoPagamentoId(id)); }}
        />
      )}
    </div>
  );
}
